"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_js_1 = require("@attensi/api-js");
require("url-search-params-polyfill");
var RedirectHandler = /** @class */ (function () {
    function RedirectHandler(plugin, options) {
        this.checkAuth = true;
        this.localStorageAccessTokenName = ACCESS_TOKEN;
        this.removeParams = true;
        this.loginURL = this.defaultLoginUrl;
        this.redirectURL = window.location.href.split('?')[0];
        this.requireOnboarding = true;
        this.debug = false;
        this.debug = options.debug || this.debug;
        this.plugin = plugin;
        this.initOptions(options);
        this.handleQueryParameters();
        if (this.removeParams) {
            window.history.pushState({}, '', window.location.href.split('?')[0]);
        }
    }
    RedirectHandler.prototype.redirectToLogout = function () {
        this.clearLocalStorage();
        var url = this.loginURL + "?logout=true&" + this.queryParams;
        this.log("Redirecting to logout: " + url);
        window.location.href = url;
    };
    RedirectHandler.prototype.redirectToLogin = function () {
        var url = this.loginURL + "?" + this.queryParams;
        this.log("Redirecting to login: " + url);
        window.location.href = url;
    };
    RedirectHandler.prototype.redirectToUrl = function (targetUrl) {
        var url = targetUrl + "?" + this.simpleQueryParams;
        this.log("Redirecting to url: " + url);
        window.location.href = url;
    };
    RedirectHandler.prototype.redirectToAttensiProduct = function (name) {
        var url = "https://" + name + ".attensi.com/" + this.subdomain + "?" + this.simpleQueryParams;
        this.log("Redirecting to attensi product: " + url);
        window.location.href = url;
    };
    RedirectHandler.prototype.initOptions = function (options) {
        this.checkAuth = options.checkAuth ? options.checkAuth : this.checkAuth;
        // tslint:disable-next-line:max-line-length
        this.localStorageAccessTokenName = options.localStorageAccessTokenName ? options.localStorageAccessTokenName : this.localStorageAccessTokenName;
        this.removeParams = options.removeParams ? options.removeParams : this.removeParams;
        this.loginURL = options.loginURL ? options.loginURL : this.defaultLoginUrl;
        this.redirectURL = options.redirectURL ? options.redirectURL : this.redirectURL;
        this.requireOnboarding = options.requireOnboarding ? options.requireOnboarding : this.requireOnboarding;
    };
    RedirectHandler.prototype.handleQueryParameters = function () {
        var query = new URLSearchParams(window.location.search);
        var accessTokenParam = query.get(ACCESS_TOKEN);
        var apiTokenParam = query.get(API_TOKEN);
        var environmentParam = query.get(ENVIRONMENT);
        var subdomainParam = query.get(SUBDOMAIN);
        this.accessToken = accessTokenParam ? accessTokenParam : this.accessToken;
        this.apiToken = apiTokenParam ? apiTokenParam : this.apiToken;
        this.environment = environmentParam ? environmentParam : this.environment;
        this.subdomain = subdomainParam ? subdomainParam : this.subdomain;
    };
    Object.defineProperty(RedirectHandler.prototype, "queryParams", {
        get: function () {
            var query = '';
            query += API_TOKEN + "=" + this.apiToken;
            query += "&" + ENVIRONMENT + "=" + this.environment;
            query += "&" + REDIRECT + "=" + this.redirectURL;
            query += "&" + REQUIRE_ONBOARDING + "=" + this.requireOnboarding;
            query += "&" + SUBDOMAIN + "=" + this.subdomain;
            return query;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RedirectHandler.prototype, "simpleQueryParams", {
        get: function () {
            var query = '';
            query += ACCESS_TOKEN + "=" + this.accessToken;
            query += "&" + API_TOKEN + "=" + this.apiToken;
            query += "&" + ENVIRONMENT + "=" + this.environment;
            query += "&" + SUBDOMAIN + "=" + this.subdomain;
            return query;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RedirectHandler.prototype, "accessToken", {
        get: function () {
            if (this.plugin.portal.accessToken) {
                return this.plugin.portal.accessToken;
            }
            if (localStorage.getItem(this.localStorageAccessTokenName)) {
                return localStorage.getItem(this.localStorageAccessTokenName);
            }
            return null;
        },
        set: function (accessToken) {
            if (accessToken === null) {
                this.plugin.setOptions({ accessToken: null });
                localStorage.removeItem(this.localStorageAccessTokenName);
            }
            else {
                this.plugin.setOptions({ accessToken: accessToken });
                localStorage.setItem(this.localStorageAccessTokenName, accessToken);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RedirectHandler.prototype, "apiToken", {
        get: function () {
            if (this.plugin.portal.apiToken) {
                return this.plugin.portal.apiToken;
            }
            if (localStorage.getItem(API_TOKEN)) {
                return localStorage.getItem(API_TOKEN);
            }
            return '';
        },
        set: function (apiToken) {
            this.plugin.setOptions({ apiToken: apiToken });
            localStorage.setItem(API_TOKEN, apiToken);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RedirectHandler.prototype, "environment", {
        get: function () {
            if (this.plugin.portal.environment) {
                return this.plugin.portal.environment;
            }
            if (localStorage.getItem(ENVIRONMENT)) {
                return localStorage.getItem(ENVIRONMENT);
            }
            return defaultEnvionment;
        },
        set: function (environment) {
            var env = environment.toUpperCase();
            if (env in api_js_1.Environment) {
                this.plugin.setOptions({ environment: env });
                localStorage.setItem(ENVIRONMENT, env);
            }
            else {
                throw Error("Invalid environment passed to login-plugin: " + env);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RedirectHandler.prototype, "subdomain", {
        get: function () {
            if (this.plugin.portal.subdomain) {
                return this.plugin.portal.subdomain;
            }
            if (localStorage.getItem(SUBDOMAIN)) {
                return localStorage.getItem(SUBDOMAIN);
            }
            return '';
        },
        set: function (subdomain) {
            this.plugin.setOptions({ subdomain: subdomain });
            localStorage.setItem(SUBDOMAIN, subdomain);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RedirectHandler.prototype, "defaultLoginUrl", {
        get: function () {
            if (!this.plugin) {
                return LOGIN_URL_PRODUCTION;
            }
            switch (this.environment) {
                case api_js_1.Environment.PRODUCTION: {
                    return LOGIN_URL_PRODUCTION;
                }
                case api_js_1.Environment.BACKEND: {
                    return LOGIN_URL_PRODUCTION;
                }
                case api_js_1.Environment.STAGING: {
                    return LOGIN_URL_STAGING;
                }
                default: {
                    return LOGIN_URL_PRODUCTION;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    RedirectHandler.prototype.clearLocalStorage = function () {
        localStorage.removeItem(this.localStorageAccessTokenName);
        localStorage.removeItem(API_TOKEN);
        localStorage.removeItem(ENVIRONMENT);
        localStorage.removeItem(SUBDOMAIN);
    };
    RedirectHandler.prototype.log = function (message) {
        if (this.debug) {
            // tslint:disable-next-line:no-console
            console.log("[ATTENSI-LOGIN-VUE][REDIRECT-HANDLER]: " + message);
        }
    };
    return RedirectHandler;
}());
exports.default = RedirectHandler;
var defaultEnvionment = api_js_1.Environment.PRODUCTION;
var LOGIN_URL_PRODUCTION = 'https://login.attensi.com';
var LOGIN_URL_STAGING = 'https://login-staging.attensi.com';
var ACCESS_TOKEN = 'access_token';
var API_TOKEN = 'api_token';
var ENVIRONMENT = 'environment';
var SUBDOMAIN = 'subdomain';
var REDIRECT = 'redirect';
var REQUIRE_ONBOARDING = 'require_onboarding';
